import React from "react";

import DateFilterGroup from "./DateFilterGroup";
import { isValidDate } from "../../util/FormUtils";
import "./PullListWorkflowFilters.css";

const PullListWorkflowFilters = ({ dateFilters, setDateFilters }) => {
    const handleDateChange = (field, startOrEnd, date) => {
        const newFilter = { ...dateFilters[field] };
        
        if (isValidDate(date)) {
            if (isValidDate(newFilter.end) && startOrEnd === "start" && date > newFilter.end) {
                [newFilter.start, newFilter.end] = [newFilter.end, date];
            } else if (isValidDate(newFilter.start) && startOrEnd === "end" && date < newFilter.start) {
                [newFilter.start, newFilter.end] = [date, newFilter.start];
            } else {
                newFilter[startOrEnd] = date;
            }
            setDateFilters({ ...dateFilters, [field]: newFilter });
        } else {
            newFilter[startOrEnd] = null;
            setDateFilters({ ...dateFilters, [field]: newFilter });
        }
    }

    const handleClearFilter = (field) => {
        setDateFilters({ ...dateFilters, [field]: { start: null, end: null } });
    }

    return (
        <div className="workflowDateFilterWindow" onClick={(e) => e.stopPropagation()}>
            <div className="workflowDateFilterGroup">
                <DateFilterGroup
                    dateFilters={dateFilters}
                    field={"createdAt"}
                    label={"Date Opened"}
                    handleDateChange={handleDateChange}
                    handleClearFilter={handleClearFilter}
                />
            </div>
            <div className="workflowDateFilterGroup">
                <DateFilterGroup
                    dateFilters={dateFilters}
                    field={"updatedAt"}
                    label={"Last Updated"}
                    handleDateChange={handleDateChange}
                    handleClearFilter={handleClearFilter}
                />
            </div>
            <div className="workflowDateFilterGroup">
                <DateFilterGroup
                    dateFilters={dateFilters}
                    field={"epApprovalDate"}
                    label={"Date EP Approved"}
                    handleDateChange={handleDateChange}
                    handleClearFilter={handleClearFilter}
                />
            </div>
            <div className="workflowDateFilterGroup">
                <DateFilterGroup
                    dateFilters={dateFilters}
                    field={"plApprovalDate"}
                    label={"Date Pull List Approved"}
                    handleDateChange={handleDateChange}
                    handleClearFilter={handleClearFilter}
                />
            </div>
            <div className="workflowDateFilterGroup">
                <DateFilterGroup
                    dateFilters={dateFilters}
                    field={"expectedDataDate"}
                    label={"Expected Data Transfer to ITN"}
                    handleDateChange={handleDateChange}
                    handleClearFilter={handleClearFilter}
                />
            </div>
            <div className="workflowDateFilterGroup">
                <DateFilterGroup
                    dateFilters={dateFilters}
                    field={"resultsReceivedDate"}
                    label={"DCT Data Received"}
                    handleDateChange={handleDateChange}
                    handleClearFilter={handleClearFilter}
                />
            </div>
            <div className="workflowDateFilterGroup">
                <DateFilterGroup
                    dateFilters={dateFilters}
                    field={"resultsValidatedDate"}
                    label={"DCT Data Validation Complete"}
                    handleDateChange={handleDateChange}
                    handleClearFilter={handleClearFilter}
                />
            </div>
        </div>
    );
}

export default PullListWorkflowFilters;